import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess
} from "../actions/ActionTypes";
import { remove } from "lodash";

const PREACHERS = "preachers";
const PREACHER = "preacher";
const initialState = { list: [], currentPreacher: {} };
const sorter = (a, b) => new Date(a.created_at) > new Date(b.created_at);
export default function preachers(state = initialState, action = {}) {
  switch (action.type) {
    case "NEW_PREACHER":
      return {
        ...state,
        currentPreacher: {}
      };
    case "EDIT_PREACHER":
      return {
        ...state,
        currentPreacher: action.data
      };
    case sagaListSuccess(PREACHERS):
      let list = action.data.data.sort(sorter);
      return { ...state, list };
    case sagaOneSuccess(PREACHER):
      return { ...state, currentPreacher: action.data.data };
    case sagaCreateSuccess(PREACHER):
      state.list.push(action.data.data);
      state.list.sort(sorter);
      return { ...state, currentPreacher: action.data.data };

    case sagaUpdateSuccess(PREACHER):
      let updatedPreacher = action.data.data;
      remove(state.list, x => x.id === updatedPreacher.id);
      state.list.push(updatedPreacher);
      state.list.sort(sorter);
      return { ...state, currentPreacher: action.data.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/preachers.js